import { Beacon, UpdateActiveStep } from '@/components/forms/FormContext';
import {
	type StepMap,
	steps,
} from '@/app/replace/virtual/components/ReplaceVirtuallyForm/constants';

// Which step this is, and where this step can go
export const systemAgeStepGraph: Beacon<StepMap> = {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore, you'll fix this by updating the steps object
	[steps.SystemAge]: [steps.SystemIssues],
};

// The function that tells the form context which step to go to next, this is
// only needed if the step goes to another step. If it is the last step, you
// don't need this function.
export const handleNext: UpdateActiveStep = <StepMap>(): StepMap => {
	return steps.SystemIssues as StepMap;
};
